export const prefix = process.env.NODE_ENV === "development" ? '' : ''
export const api =  process.env.NODE_ENV === "development" ? 'https://local.vrmaker.vip:37086' : 'https://local.vrmaker.vip:37086' 
// export const api =  process.env.NODE_ENV === "development" ? 'http://192.168.33.251/' : 'http://192.168.33.251/' 
